import React from "react";
import { niceDate, yearFromNow } from "../../util/util";

const styles = {
  section: {
    border: "2px solid #000",
    padding: "10px",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "15px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "10px",
  },
  tableCell: {
    border: "1px solid #000",
    padding: "4px",
    fontSize: "12px",
  },
  checkbox: {
    marginRight: "5px",
  },
  signatureLine: {
    borderTop: "1px solid #000",
    marginTop: "15px",
    paddingTop: "5px",
    fontSize: "12px",
  },
};

const CheckboxItem = ({ label }) => (
  <div>
    <span style={styles.checkbox}>☐</span>
    {label}
  </div>
);

const SignatureLine = ({ label }) => (
  <div style={styles.signatureLine}>
    {label}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "5px",
      }}
    >
      <span>Date: ________</span>
      <span>Time: ________</span>
    </div>
  </div>
);

const BedHeadTicket = (data) => {
  const { patientName, patientGenericPid, patientDob, patientSex, onDay } =
    data.data;
  return (
    <section style={styles.section}>
      <h3 style={{ ...styles.sectionTitle, fontSize: "16px" }}>
        Bed Head Ticket
      </h3>
      <div style={styles.patientInfo}>
        <p>
          Patient Name: <u>{patientName}</u> Age: <u>{niceDate(patientDob)}</u>{" "}
          Yrs. <u>{patientSex}</u>
        </p>
        <p>
          PID No.: <u>{patientGenericPid}</u> Date: <u>{niceDate(onDay)}</u>
        </p>
      </div>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell}>Case No.:</td>
            <td style={styles.tableCell}>Bed No.:</td>
            <td style={styles.tableCell}>Anaesthesia Time:</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Start Time of Surgery:</td>
            <td style={styles.tableCell} colSpan="2">
              End Time of Surgery:
            </td>
          </tr>
        </tbody>
      </table>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell} colSpan="2">
              <strong>In Ward Pre Operative</strong>
            </td>
            <td style={styles.tableCell} colSpan="2">
              <strong>Investigations</strong>
            </td>
          </tr>
          <tr>
            <td style={styles.tableCell}>BP (mm of Hg)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>PPBS</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Pulse (bpm)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>ECG</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>
              SPO<sub>2</sub> (%)
            </td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>Others</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Blood Sugar (mg/dl)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell} colSpan="2">
              Additional Notes
            </td>
          </tr>
        </tbody>
      </table>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableCell} colSpan="3">
              Topical/ Local Anaesthetic Medication
            </th>
          </tr>
          <tr>
            <th style={styles.tableCell}>Medication</th>
            <th style={styles.tableCell}>Time/Ward</th>
            <th style={styles.tableCell}>Time/BR</th>
          </tr>
        </thead>
        <tbody>
          {[
            "Proparacaine 0.5% drop",
            "Lignocaine 2% injection",
            "Lignocaine 4% drop",
            "Bupivacaine/ Ropivacaine 0.5% injection",
            "Others",
          ].map((med, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>
                <span style={styles.checkbox}>☐</span>
                {med}
              </td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
            </tr>
          ))}
        </tbody>
      </table>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableCell} colSpan="3">
              Ophthalmic Medication
            </th>
          </tr>
          <tr>
            <th style={styles.tableCell}>Medication</th>
            <th style={styles.tableCell}>Time/Ward</th>
            <th style={styles.tableCell}>Time/BR</th>
          </tr>
        </thead>
        <tbody>
          {[
            "Moxifloxacin 0.5%",
            "Atropine 1%",
            "Flurbiprofen 0.03%/ Nepafenac 0.1%",
            "Tropicamide 0.8% + Phenylephrine 5%",
            "Povidone iodine 5%",
            "Others",
          ].map((med, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>
                <span style={styles.checkbox}>☐</span>
                {med}
              </td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
            </tr>
          ))}
        </tbody>
      </table>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell}>OT Notes</td>
          </tr>
          <tr>
            <td style={{ ...styles.tableCell, height: "10px" }}></td>
          </tr>
        </tbody>
      </table>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell}>
              <strong>In Ward Post-operative</strong>
              <div>BP</div>
              <div>Pulse</div>
              <div>
                SPO<sub>2</sub>
              </div>
            </td>
            <td style={styles.tableCell}>
              <strong>Medication Advice</strong>
              <div style={{ height: "20px" }}></div>
            </td>
            <td style={styles.tableCell}>
              <strong>Clinical Discharge Criteria (CDC)</strong>
              <CheckboxItem label="1. Patient alert and oriented" />
              <CheckboxItem label="2. No nausea and vomiting" />
              <CheckboxItem label="3. No significant bleeding" />
              <CheckboxItem label="4. Steady gait" />
              <CheckboxItem label="5. Passed urine" />
              <CheckboxItem label="6. Taken liquid/ solid" />
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        Remarks:
        <CheckboxItem label="Patient discharged in good condition" />
        <CheckboxItem label="Patient is transferred" />
      </div>

      <SignatureLine label="Signature of Anaesthesist / Physician-in-charge" />
      <SignatureLine label="Signature of Nurse/ Ward Staff" />
      <SignatureLine label="Signature of Surgeon" />
    </section>
  );
};

const PatientInvestigationChecklist = (data) => {
  const {
    patientName,
    patientGenericPid,
    patientDob,
    patientSex,
    onDay,
    _id,
    site,
  } = data.data;
  const investigations = [
    "Biometry",
    "Blood Sugar Fasting, PP, HbA1C",
    "ECG",
    "Echo Cardiography",
    "Serology Profile: HBV/ HCV/ HIV",
    "X-Ray Chest Pa View",
    "OCT",
    "OPTOS",
    "Previous Surgery Documents",
    "Specular",
  ];

  return (
    <section style={styles.section}>
      <u>
        <h3 style={{ ...styles.sectionTitle, fontSize: "16px" }}>
          Patient Investigation Checklist
        </h3>
      </u>
      <div style={{ fontSize: "15px" }}>
        <p>
          Patient Name:{" "}
          <b>
            <u>{patientName}</u>
          </b>{" "}
          Age:{" "}
          <b>
            <u>{yearFromNow(patientDob)}</u>
          </b>{" "}
          Gender:{" "}
          <b>
            <u>{patientSex}</u>
          </b>
        </p>
        <p>
          PID No.:{" "}
          <b>
            <u>{patientGenericPid}</u>
          </b>{" "}
          Date:{" "}
          <b>
            <u>{niceDate(onDay)}</u>
          </b>
        </p>
        <p>
          Branch:
          <b>
            <u>{site}</u>
          </b>
        </p>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableCell}>Sl. No.</th>
            <th style={styles.tableCell}>Investigation Details</th>
            <th style={styles.tableCell}>Ward Personnel (ü)</th>
            <th style={styles.tableCell}>Block Room Attendant (ü)</th>
            <th style={styles.tableCell}>OT Floor Assistant (ü)</th>
          </tr>
        </thead>
        <tbody>
          {investigations.map((item, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>{index + 1}</td>
              <td style={styles.tableCell}>{item}</td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
            </tr>
          ))}
        </tbody>
      </table>

      <div>
        Remarks if any: _________________________________________________
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <SignatureLine label="Signature" />
        <SignatureLine label="Signature" />
        <SignatureLine label="Signature" />
      </div>
    </section>
  );
};

const BedHeadTicketPage1 = (data) => {
  const {
    patientName,
    patientGenericPid,
    patientDob,
    patientSex,
    onDay,
    _id,
    site,
  } = data.data;
  return (
    <section style={styles.section}>
      <u>
        <h3 style={{ ...styles.sectionTitle, fontSize: "16px" }}>
          Bed Head Ticket
        </h3>
      </u>
      <div style={{ fontSize: "15px" }}>
        <p>
          Patient Name:{" "}
          <b>
            <u>{patientName}</u>
          </b>{" "}
          Age:{" "}
          <b>
            <u>{yearFromNow(patientDob)}</u>
          </b>{" "}
          Gender:{" "}
          <b>
            <u>{patientSex}</u>
          </b>
        </p>
        <p>
          PID No.:{" "}
          <b>
            <u>{patientGenericPid}</u>
          </b>{" "}
          Date:{" "}
          <b>
            <u>{niceDate(onDay)}</u>
          </b>
        </p>
        <p>
          Branch:
          <b>
            <u>{site}</u>
          </b>
        </p>
      </div>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell}>Case No.:</td>
            <td style={styles.tableCell}>Bed No.:</td>
            <td style={styles.tableCell}>Anaesthesia Time:</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Start Time of Surgery:</td>
            <td style={styles.tableCell} colSpan="2">
              End Time of Surgery:
            </td>
          </tr>
        </tbody>
      </table>

      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.tableCell} colSpan="2">
              <strong>In Ward Pre Operative</strong>
            </td>
            <td style={styles.tableCell} colSpan="2">
              <strong>Investigations</strong>
            </td>
          </tr>
          <tr>
            <td style={styles.tableCell}>BP (mm of Hg)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>PPBS</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Pulse (bpm)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>ECG</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>
              SPO<sub>2</sub> (%)
            </td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell}>Others</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Blood Sugar (mg/dl)</td>
            <td style={styles.tableCell}></td>
            <td style={styles.tableCell} colSpan="2">
              Additional Notes
            </td>
          </tr>
        </tbody>
      </table>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableCell} colSpan="3">
              Topical/ Local Anaesthetic Medication
            </th>
          </tr>
          <tr>
            <th style={styles.tableCell}>Medication</th>
            <th style={styles.tableCell}>Time/Ward</th>
            <th style={styles.tableCell}>Time/BR</th>
          </tr>
        </thead>
        <tbody>
          {[
            "Proparacaine 0.5% drop",
            "Lignocaine 2% injection",
            "Lignocaine 4% drop",
            "Bupivacaine/ Ropivacaine 0.5% injection",
            "Others",
          ].map((med, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>
                <span style={styles.checkbox}>☐</span>
                {med}
              </td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
            </tr>
          ))}
        </tbody>
      </table>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableCell} colSpan="3">
              Ophthalmic Medication
            </th>
          </tr>
          <tr>
            <th style={styles.tableCell}>Medication</th>
            <th style={styles.tableCell}>Time/Ward</th>
            <th style={styles.tableCell}>Time/BR</th>
          </tr>
        </thead>
        <tbody>
          {[
            "Moxifloxacin 0.5%",
            "Atropine 1%",
            "Flurbiprofen 0.03%/ Nepafenac 0.1%",
            "Tropicamide 0.8% + Phenylephrine 5%",
            "Povidone iodine 5%",
            "Others",
          ].map((med, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>
                <span style={styles.checkbox}>☐</span>
                {med}
              </td>
              <td style={styles.tableCell}></td>
              <td style={styles.tableCell}></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

const BedHeadTicketPage2 = () => (
  <section style={styles.section}>
    <table style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.tableCell}>OT Notes</td>
        </tr>
      </tbody>
    </table>

    <table style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.tableCell}>
            <strong>In Ward Post-operative</strong>
            <div>BP</div>
            <div>Pulse</div>
            <div>
              SPO<sub>2</sub>
            </div>
          </td>
          <td style={styles.tableCell}>
            <strong>Medication Advice</strong>
            <div style={{ height: "50px" }}></div>
          </td>
          <td style={styles.tableCell}>
            <strong>Clinical Discharge Criteria (CDC)</strong>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            > */}
            <CheckboxItem label="1. Patient alert and oriented" />
            <CheckboxItem label="2. No nausea and vomiting" />
            <CheckboxItem label="3. No significant bleeding" />
            <CheckboxItem label="4. Steady gait" />
            <CheckboxItem label="5. Passed urine" />
            <CheckboxItem label="6. Taken liquid/ solid" />
            {/* </div> */}
          </td>
        </tr>
      </tbody>
    </table>

    <div>
      Remarks:
      <CheckboxItem label="Patient discharged in good condition" />
      <CheckboxItem label="Patient is transferred" />
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <SignatureLine label="Signature of Anaesthesist / Physician-in-charge" />
      <SignatureLine label="Signature of Nurse/ Ward Staff" />
      <SignatureLine label="Signature of Surgeon" />
    </div>
  </section>
);

const BedHeadChecklist = (props) => (
  <div style={styles.app}>
    <BedHeadTicketPage1 data={props.data} />
    {/* <div style={{ pageBreakAfter: "always" }}></div> */}
    <BedHeadTicketPage2 />
    <div style={{ pageBreakAfter: "always" }}></div>
    <PatientInvestigationChecklist data={props.data} />
  </div>
);

export default BedHeadChecklist;
